import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { AppConfig } from "../../../app.settings";
import { MachineCategory } from "../../models/entities/machine-category.type";
import { MachineCategoryShareModel } from "../../models/entities/machine-category-share.type";

@Injectable({
  providedIn: 'root'
})
export class MachineCategoriesService {
  private endpoint: string;

  constructor(
    private readonly http: HttpClient,
    private readonly config: AppConfig
  ) {
    this.endpoint = `${this.config.getConfig('api')}DeviceCategories`;
  }

  getAllCategories(): Observable<MachineCategory[]> {
    return this.http.get<MachineCategory[]>(`${this.endpoint}/GetAllCategoriesByCurrentUser`);
  }

  getAllCategoriesByUser(userId: string): Observable<MachineCategory[]> {
    const params: HttpParams = new HttpParams().set('userId', userId);
    return this.http.get<MachineCategory[]>(`${this.endpoint}/GetAllCategoriesByUser`, { params });
  }

  shareCategoryWithUser(userId: string, categoryId: number): Observable<void> {
    const categoryShareModel = new MachineCategoryShareModel(userId, categoryId);
    return this.http.post<void>(`${this.endpoint}/ShareDeviceCategoryWithUser`, categoryShareModel);
  }

  createCategory(data: MachineCategory): Observable<void> {
    return this.http.post<void>(`${this.endpoint}/CreateCategory`, data);
  }

  updateCategory(data: MachineCategory): Observable<void> {
    return this.http.put<void>(`${this.endpoint}/UpdateCategory`, data);
  }

  deleteCategory(id: number): Observable<void> {
    const params: HttpParams = new HttpParams().set('id', id);
    return this.http.delete<void>(`${this.endpoint}/DeleteCategory`, { params });
  }
}
